import PendoIcon from '../../../../components/icon/pendo-icon.vue.js';
import PendoDivider from '../../../../components/divider/pendo-divider.vue.js';

var script = {
  name: 'PendoGuideElementTypeAction',
  components: {
    PendoIcon,
    PendoDivider
  },
  props: {
    uiElements: {
      type: Array,
      required: true,
      validator: elems => elems.every(el => el.name)
    },
    iconSize: {
      type: Number,
      default: 14
    }
  },
  methods: {
    showDivider(index) {
      const hasMoreThanOneElement = this.uiElements.length > 1;
      const isIndexAtTheLastElement = index === this.uiElements.length - 1;
      return hasMoreThanOneElement && !isIndexAtTheLastElement;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-element-type-action.vue2.js.map
